import { Button } from '@heroui/react';
import { Xmark } from '@gravity-ui/icons';
import { useTranslation } from 'react-i18next';
import { useViewerStore } from '@stores/viewerStore';

export function HotspotInfoCard() {
  const { t } = useTranslation();
  const sceneConfig = useViewerStore((s) => s.sceneConfig);
  const activeIndex = useViewerStore((s) => s.activeHotspotIndex);
  const setActiveIndex = useViewerStore((s) => s.setActiveHotspotIndex);
  const hotspots = sceneConfig?.hotspots ?? [];
  const hotspot = activeIndex !== null ? hotspots[activeIndex] : null;

  if (!hotspot) return null;

  return (
    <div className="pointer-events-auto absolute top-20 right-4 z-40 w-80 overflow-hidden rounded-3xl bg-white/12 shadow-2xl ring-1 ring-white/15 backdrop-blur-xl">
      {hotspot.imageUrl && (
        <img src={hotspot.imageUrl} alt="" className="h-36 w-full object-cover" draggable={false} />
      )}
      <div className="p-5">
        <div className="mb-3 flex items-start justify-between gap-3">
          <div>
            <p className="text-xs font-medium tracking-[0.18em] text-white/45 uppercase">
              {t('hotspots.hotspot')}
            </p>
            <h3 className="mt-1 text-lg font-semibold text-white">{hotspot.title}</h3>
          </div>
          <Button
            isIconOnly
            size="sm"
            onPress={() => setActiveIndex(null)}
            aria-label={t('hotspots.closeHotspot')}
            className="size-7 min-w-7 rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white"
          >
            <Xmark width={14} height={14} />
          </Button>
        </div>
        {hotspot.description ? (
          <p className="text-sm leading-relaxed text-white/70">{hotspot.description}</p>
        ) : (
          <p className="text-sm text-white/35 italic">{t('hotspots.noDescription')}</p>
        )}
      </div>
    </div>
  );
}
